const MINUTE = 1000 * 60;
const DEFAULT_TTL = 5 * MINUTE;
export class TtlCache {
    constructor({ ttlMs = DEFAULT_TTL } = {}) {
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "timers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ttl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (ttlMs < 0) {
            throw new Error('default TTL must be zero or greater');
        }
        this.data = new Map();
        this.timers = new Map();
        this.ttl = ttlMs;
    }
    set(key, value, ttl) {
        this.setTimeout(key, ttl !== null && ttl !== void 0 ? ttl : this.ttl);
        this.data.set(key, value);
    }
    get(key) {
        return this.data.get(key);
    }
    has(key) {
        return this.data.has(key);
    }
    delete(key) {
        this.cancelTimeout(key);
        this.data.delete(key);
    }
    clear() {
        this.data.clear();
        this.timers.forEach(value => clearTimeout(value));
        this.timers.clear();
    }
    cancelTimeout(key) {
        const id = this.timers.get(key);
        if (id) {
            clearTimeout(id);
            this.timers.delete(key);
        }
    }
    setTimeout(key, ttl) {
        this.cancelTimeout(key);
        if (ttl < 0) {
            return;
        }
        const id = setTimeout(() => this.delete(key), ttl);
        this.timers.set(key, id);
    }
}
//# sourceMappingURL=ttl-cache.js.map